import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=53b544f8&scoped=true&"
import script from "./BackTop.vue?vue&type=script&lang=js&"
export * from "./BackTop.vue?vue&type=script&lang=js&"
import style0 from "styles/components/backtop.css?vue&type=style&index=0&id=53b544f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b544f8",
  null
  
)

export default component.exports